__turbopack_context__.v({
  "heroCtas": "_0NV6Hq_heroCtas",
  "heroLink": "_0NV6Hq_heroLink",
});
